<template>
  <b-row
    align-v="center"
    no-gutters
  >
    <b-col>
      <BaseSelect
        :id="id"
        :value="value"
        :resource="$data.$constants.RESOURCES.RESOURCE_PROJECTS"
        class="base-action-select"
        :disabled="disabled"
        @input="$emit('input', $event)"
        :error="error"
      />
    </b-col>
    <b-col
      v-show="!disabled"
      v-access="{
        resource: $data.$constants.RESOURCES.RESOURCE_PROJECTS,
        resourceAction: $data.$constants.RESOURCE_ACTIONS.RESOURCE_ACTION_ALL
      }"
      cols="auto"
    >
      <b-button
        variant="primary"
        class="text-nowrap rounded-right d-inline-block base-select-add-button"
        @click="creationModalVisible = true"
      >
        <feather-icon
          icon="PlusIcon"
          size="19"
        />
      </b-button>
    </b-col>
    <ProjectCreationModal
      v-model="creationModalVisible"
      @project-created="$emit('input', $event)"
    />
  </b-row>
</template>

<script>
import BaseSelect from '@/components/ui/select/BaseSelect.vue'
import ProjectCreationModal from '@/components/projects/modal/ProjectCreationModal.vue'

export default {
  name: 'ProjectSelect',
  components: { ProjectCreationModal, BaseSelect },
  props: {
    id: {
      type: String,
      default: null,
    },
    value: {
      type: [Object, String, Number],
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      default: null,
    }
  },
  data() {
    return {
      creationModalVisible: false,
    }
  },
}
</script>

<style scoped>
</style>
